import React from 'react';
import { observer } from 'mobx-react';
import ExportCsvService from '../services/ExportCsvService';
import ExportCsvDialog from './ExportCsvDialog';

const ExportCsvDialogContainer = () => {
  return (
    <ExportCsvDialog
      values={ExportCsvService.form.getValues()}
      errors={ExportCsvService.form.errors}
      isOpen={ExportCsvService.isOpen}
      onClose={ExportCsvService.handleCloseDialog}
      onDownload={ExportCsvService.handleDownload}
      onChange={ExportCsvService.form.setValue}
      submitting={ExportCsvService.download.fetching}
      downloadError={!!ExportCsvService.download.error}
    />
  );
};

export default observer(ExportCsvDialogContainer);
